// extracted by mini-css-extract-plugin
export default {"root":"vqVTxAgx4k","root_measurements":"vDNmKoayMC","button":"k75iaaxWe8"};